import axios from "../services/axios-config.js";


// FUNÇÃO DE BUSCA DAS AVALIAÇÕES DO APP
export const getReviews = async () => {
    try {
        const res = await axios.get(`/rating/app/reviews`);

        // QUALQUER RESPOSTA QUE NÃO SEJA UMA LISTA É TRATADA COMO FALHA, PARA A TELA NÃO CONFUNDIR COM "SEM AVALIAÇÕES"
        if (res.status == 200 && Array.isArray(res.data)) {
            return res.data;
        }

        throw new Error(`Resposta inesperada ao buscar as avaliações (status ${res.status}).`);

    } catch (error) {
        console.error("ERROR - GET REVIEWS FUNCTION:", error);
        throw error;
    }
};
